import { alpacaGrassABI } from '@/utils/abi';
import BigNumber from 'bignumber.js';
import { EventBus } from '@/utils/EventBus';
import { metaMaskErrorHandler, MetaError } from '@/utils/errorHandler';

const contracts: any[] = [null, null, null];
const contractAddresses = [
  process.env.VUE_APP_GRASS_0_CONTRACT_ADDRESS,
  process.env.VUE_APP_GRASS_1_CONTRACT_ADDRESS,
  process.env.VUE_APP_GRASS_2_CONTRACT_ADDRESS,
];

export const initContract = (pid: number) => {
  if (window.web3 && contracts[pid] === null) {
    contracts[pid] = new window.web3.eth.Contract(alpacaGrassABI, contractAddresses[pid]);
  }
};

export const payment = async (pid: number) => {
  initContract(pid);
  try {
    const amount = await contracts[pid].methods.payment().call();
    return window.web3.utils.fromWei(amount, 'ether');
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const feed = async (pid: number, eth: BigNumber, sender: string, owner: string, id: string) => {
  initContract(pid);
  try {
    const res = await contracts[pid].methods.feed(owner, id).send({
      value: window.web3.utils.toWei(`${eth}`, 'ether'),
      from: sender,
    }).once('sending', () => {
      EventBus.$emit('trx-result', { status: 'loading', trxId: '' });
    }).once('transactionHash', (hash: string) => {
      EventBus.$emit('trx-result', { status: 'completed', trxId: hash });
    }).on('error', (err: MetaError) => {
      metaMaskErrorHandler(err);
    });
  } catch (err) {
    metaMaskErrorHandler(err);
  }
};
